import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

interface SalesChannel {
  id: number
  slug: string
  label: string
  active: boolean
}

interface Props {
  value: string | null | undefined
  onChange: (slug: string) => void
  placeholder?: string
  required?: boolean
  disabled?: boolean
  /** Dacă true, include și valorile inactive (când editezi un rând cu canal dezactivat). */
  includeInactive?: boolean
  className?: string
}

export function ChannelSelect({
  value,
  onChange,
  placeholder = 'Selectează canal...',
  required,
  disabled,
  includeInactive,
  className,
}: Props) {
  const query = useQuery<{ channels: SalesChannel[] }>({
    queryKey: ['sales-channels'],
    queryFn: async () =>
      (await api.get<{ channels: SalesChannel[] }>('/settings/sales-channels')).data,
    staleTime: 5 * 60_000, // cache 5 min — lista nu se schimbă des
  })

  const all = query.data?.channels ?? []
  const list = includeInactive ? all : all.filter((c) => c.active)
  // Dacă valoarea curentă nu e în lista activă (canal dezactivat), forțează includere
  const valueInList = list.some((c) => c.slug === value || c.label === value)
  const visible = valueInList || !value ? list : [...list, ...all.filter((c) => c.slug === value)]

  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      disabled={disabled}
      className={
        className ??
        'w-full rounded border border-b4l-border bg-white px-2 py-1.5 text-sm disabled:bg-b4l-bg-soft'
      }
    >
      <option value="">{placeholder}</option>
      {visible.map((c) => (
        <option key={c.id} value={c.slug}>
          {c.label}
          {!c.active && ' (inactiv)'}
        </option>
      ))}
      {/* Fallback: dacă valoarea curentă nu e în niciun canal (text liber legacy), o afișează */}
      {value && !visible.some((c) => c.slug === value || c.label === value) && (
        <option value={value}>{value} (legacy)</option>
      )}
    </select>
  )
}
